export default __webpack_public_path__ + "static/media/direct-debit.8894967e.svg";